<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-8 ps-5">
                <h2 class="col pb-2 title">
                    {{ "LOADLIMITMANAGEMENT" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "LOADLIMITMANAGEMENT_SUBTITLE" | translate }}</h6>
            </div>
            @if(authService.isAuthorized([PermissionEnum.Loadlimit_add])){
            <div class="col-md-4 pe-5 d-flex justify-content-end align-items-center"
                [routerLink]="['/load-limit-setup']">
                <button class="button-add-device">
                    {{ "CREATELOADLIMIT" | translate }}
                </button>
            </div>
            }
        </div>
        <div class="row g-0 m-0">
            <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
                <app-load-limit-filter class="pe-2"
                [numberOfResults]="numberOfLoadLimits"
                [selectedRegions]="selectedFilters.regions || []"
                [selectedLimitTypes]="selectedFilters.limitTypes || []"
                (applied)="onDataReceived($event)">
            </app-load-limit-filter>
                <app-status [statuses]="targets" class="pe-2" (close)="onTargetOption($event)"  [title]="'LOADLIMIT_TARGET' | translate"></app-status>
                <app-status [statuses]="meterPhases" class="pe-2" (close)="onMeterPhaseOption($event)"  [title]="'DEVICESETUP_METERPHASE' | translate"></app-status>
                <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
                <!--#region Datepicker-->
                <div class="datepicker-container-wrapper position-relative">
                    <div class="button-wrapper">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleModal()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleModal()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
                    }
                </div>
                <app-search class="ps-2" placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)"></app-search>
            </div>
            <div class="row g-0 m-0 pt-3">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "LOADLIMIT_TARGET" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "LOADLIMITMANAGEMENT_REGIONS" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_SERVICETYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_METERPHASE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "LOADLIMITMANAGEMENT_LIMITTYPE" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "LOADLIMITMANAGEMENT_THRESHOLD" | translate }}</span>
                            </th>
                            <th>
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DATECREATED" | translate }}</span>
                            </th>
                            <th class="column-content">
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "LOADLIMITMANAGEMENT_UPDATEDBY" | translate }}</span>
                            </th>
                            <th class="column-content">
                                <img alt="Column" src="assets/device/column-menu.svg" />
                                <span>{{ "DEVICESETUP_STATUS" | translate }}</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data; let i=index">
                            <td appIsNew [executedTime]="row.loadLimitCreationDate!" [seconds]="dayInMs"
                                class="firstLabel"></td>
                            <td>
                                <span>{{ row.target }}</span>
                            </td>
                            <td> @if (row.target === 'SingleMeter') {
                                <span
                                    (click)="clipboardService.copyToClipboardDeviceManagement(row.meterNumber!, $event, 'meterNo-' + i)"
                                    class="copyable">
                                    {{ row.meterNumber }}
                                    <span class="copy-tooltip" *ngIf="clipboardService.copiedId === 'meterNo-'+i">
                                        {{
                                        "COPIED" |
                                        translate
                                        }}
                                    </span>
                                    </span>
                                }
                                @else {
                                @if (!row.regionNames || row.regionNames.length < 1) { <span>-</span>
                                    }
                                    @else {
                                    <div class="d-flex align-items-center">
                                        <span class="label-box"
                                            [ngStyle]="{ 'background-color': getRegionColor(row.regionNames[0]) }"
                                            [title]="row.regionNames.join(', ')">
                                            {{ row.regionNames[0] }}
                                        </span>

                                        @if (row.regionNames.length > 1) {
                                        <span class="ps-1 pe-1 ms-2 additional-asset-types rounded">
                                            +{{ row.regionNames.length - 1 }}
                                        </span>
                                        }
                                    </div>
                                    }
                                    }
                            </td>
                            <td>
                                <span>{{row.assetTypeName || '-'}}</span>
                            </td>
                            <td>
                                <span>{{row.serviceTypeName || '-'}}</span>
                            </td>
                            <td>
                                <span>{{row.meterPhase || '-'}}</span>
                            </td>
                            <td>
                                <span>{{ row.limitType}}</span>
                            </td>
                            <td>
                                <span>
                                    {{
                                    row.limitType === LimitType.Current ? row.value + 'A' :
                                    row.limitType === LimitType.Demand ? row.value + 'kW' :
                                    row.value
                                    }}
                                </span>
                            </td>
                            <td>
                                <span>{{ row.loadLimitCreationDate | date: "dd MMM yyyy, h:mm a" }}</span>
                            </td>
                            <td>
                                <span>{{ row.createdBy }}</span>
                            </td>
                            <td>
                                <span class="status" [ngClass]="{
                                    'active': row.isActive,
                                    'inactive': !row.isActive
                                }">
                                    {{ row.isActive ? 'Active' : 'Inactive' }}
                                </span>
                            </td>
                            <td>
                                <svg-icon alt="More" class="more-icon ps-1" src="assets/settings/more-icon.svg"
                                    (click)="setActiveRow(i)"></svg-icon>
                                <div *ngIf="activeRow === i" class="positioning">
                                    <div class="overlay-light" (click)="setActiveRow(null)"></div>
                                    <div class="dropdown-button p-2">
                                        <div class="dropdown-button-menu p-0 m-0">
                                            @if (
                                            !(!row.isActive) &&
                                            authService.isAuthorized([
                                            PermissionEnum.Loadlimit_modify,
                                            ])
                                            ) {
                                            <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                                                (click)="openDeactivateModal(row)">
                                                <svg-icon alt="Deactivate"
                                                    src="assets/settings/deactivate.svg"></svg-icon>
                                                <span class="ps-2 item-title">{{
                                                    "DEACTIVATE" | translate
                                                    }}</span>
                                            </div>
                                            }
                                            @if (
                                            !row.isActive &&
                                            authService.isAuthorized([
                                            PermissionEnum.Loadlimit_modify,
                                            ])
                                            ) {
                                            <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                                                (click)="openActivateModal(row.id!)">
                                                <svg-icon alt="Activate" class="pb-1"
                                                    src="assets/settings/activate.svg"></svg-icon>
                                                <span class="ps-2 item-title">{{
                                                    "ACTIVATE" | translate
                                                    }}</span>
                                            </div>
                                            }
                                            @if (
                                            !row.isActive &&
                                            authService.isAuthorized([
                                            PermissionEnum.Loadlimit_modify,
                                            ])
                                            ) {
                                            <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                                                (click)="editLoadLimit(row.id!)">
                                                <svg-icon alt="Edit" class="pb-1"
                                                    src="assets/device/edit.svg"></svg-icon>
                                                <span class="ps-2 item-title">{{
                                                    "EDITLOADLIMIT" | translate
                                                    }}</span>
                                            </div>
                                            }
                                            @if (
                                            !row.isActive &&
                                            authService.isAuthorized([
                                            PermissionEnum.Loadlimit_delete,
                                            ])
                                            ) {
                                            <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                                                (click)="isModalOpen = true; selectedRowId = row.id!">
                                                <svg-icon alt="Delete" class="pb-1"
                                                    src="assets/settings/trash-can-red.svg"></svg-icon>
                                                <span class="ps-2 item-title">{{
                                                    "DELETE" | translate
                                                    }}</span>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="container-down">
                <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfLoadLimits"
                    [pageSize]="pageSize" [currentPage]="currentPage" (pageChange)="pageChange($event)">
                </app-pagination>
            </div>
        </div>
    </div>
</div>
<app-confirm-dialog *ngIf="isModalOpen" titleKey="DELETE" question="LOADLIMITDELETE"
  (confirm)="delete(selectedRowId!)" (cancel)="isModalOpen = false; activeRow = null"></app-confirm-dialog>

@if (isActivateModalOpen) {
  <app-confirm-dialog titleKey="ACTIVATE" question="ACTIVATE_LIMITER_CONFIRM"
    (confirm)="confirmActivate()" (cancel)="cancelActivate()"></app-confirm-dialog>
}

@if (isDeactivateWarningModalOpen) {
  <app-confirm-dialog titleKey="DEACTIVATE" question="DEACTIVATE_LIMITER_WARNING"
    (confirm)="confirmDeactivate()" (cancel)="cancelDeactivate()"></app-confirm-dialog>
}
